/*
 * @Description:
 * @Author: Jack Deng
 * @Date: 2021-03-26 11:50:24
 * @LastEditors: Jack Deng
 * @LastEditTime: 2021-03-26 12:29:10
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesChannelContentEditor/SalesChannelEditorPromotion/Preview/Popup/index.tsx
 */
import React from 'react';

import styles from './style.module.less';

type Props = {
  width: string | number;
  height?: string | number;
  children: JSX.Element;
  closePosition: 'bottom' | 'top';
};

function PopUp({ width, height, children, closePosition }: Props) {
  return (
    <div className={styles.container}>
      <div className={styles.content} style={{ width, height }}>
        {closePosition === 'top' && <span className={styles.close}>{'X'}</span>}
        {children}
        {closePosition === 'bottom' && (
          <div className={styles.image}>
            <img
              src={
                'https://resource2.unifyxp.com/shopper-v2/h5/dialog_icon-close.svg'
              }
            />
          </div>
        )}
      </div>
    </div>
  );
}

export default PopUp;
